import { LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  CssBaseline,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Paper,
  TextField,
  Typography,
  Tabs, Tab,
  Container, Link,
  ButtonBase,
  Tooltip
} from '@mui/material';
import React, { act, useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate, } from 'react-router-dom';
import Grid2 from '@mui/material/Grid2';
import proxelera from '../../images/proxelera.png';
import TopAppBar from '../app/TopAppBar';
import CustomTab from '../widgets/CustomTab';
// import RegMap from '../File/RegMap';
import RegMap from "../regMap/RegMap";
import Project from './Project';
import RTLActions from '../rtl_top/RTLActions';
import { DialogWidget } from '../../Widget';
import DHSPolicy from '../other/DHSPolicy';
import { customStyles } from '../../styles/tableStyle';
import UploadInputs from '../ral_rtl/UploadInputs';
import EditIcon from '@mui/icons-material/Edit';
import LogViewer from '../other/LogViewer';
import AuthService from '../../service/AuthService';
const tabMenu = [
  { "label": "RTL", "value": 0, "content": "RTL Content", bgColor: "#c39bd3" },
  { "label": "RAL", "value": 1, "content": "RAL Content", bgColor: "#7dcea0" },
  { "label": "RTL-Top", "value": 2, "content": "RTL-Top Content", bgColor: "#aed6f1" }
]

function DashBoard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [logs, setLogs] = useState(false)
  const [project, setProject] = useState('')
  const [action, setAction] = useState('')

  useEffect(() => {
    if (AuthService.getUserInfo() == null) {
      navigate("/login")
    } else {
      const project = localStorage.getItem('projectName');
      setProject(project)
    }
  }, []);




  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const openDialog = (e, action) => {
    setAction(action)
    setDialogOpen(true);
  };
  const closeDialog = () => {
    setDialogOpen(false)
    setAction('')
  }

  const loadLogs = () => {
    setLogs(!logs)
  }

  return (
    <Box spacing={2} style={{ width: '100%', flexDirection: 'column', display: 'flex' }}>

      <TopAppBar />

      <div style={{ display: 'flex', flexDirection: 'column', padding: 2, margin: 5 }}>
        <Box sx={{ width: '100%', display: 'flex', borderBottom: 1, borderColor: 'divider' }} flexDirection={"row"}>
          <Typography variant='h6'
            style={{ alignSelf: 'center', padding: 2, color: '#FB5656', fontStyle: 'italic' }}
          >{project}

            {/* <Tooltip title={"Change Project"} style={{ color: 'black', padding: 2 }}>
              <EditIcon onClick={(e) => openDialog(e, "project")}></EditIcon>

            </Tooltip> */}
          </Typography>

          <Box sx={{ width: '100%', justifyContent: 'end', display: 'flex', flex: 2, borderBottom: 1, borderColor: 'divider' }} flexDirection={"end"}>
            <ButtonBase onClick={(e) => openDialog(e, "policy")} style={{ marginRight: 10 }}>
              <Typography sx={customStyles.hyperlink} >DHS Policy</Typography>
            </ButtonBase>
            <Tabs
              value={value}
              onChange={handleChange}
            >
              {tabMenu.map((item, index) => {
                return <CustomTab
                  key={index}
                  item={item}
                  changeValue={handleChange}
                  label={item.label}
                  index={index}
                ></CustomTab>
              })}
            </Tabs>
          </Box>
        </Box>

        {dialogOpen && action == "policy" ? <DialogWidget
          dialogContent={<DHSPolicy />}
          closeDialog={closeDialog}
        ></DialogWidget> : false}

        {dialogOpen && action == "project" ? <DialogWidget
          dialogContent={<Project disabled={false} />}
          closeDialog={closeDialog}
        ></DialogWidget> : false}
        <Grid2 container spacing={2}>
          <Grid2 size={{ md: 12, }} direction={"row"} display={"flex"}>
            <Grid2 size={{ xs: 12, md: 8 }}
              sx={{ padding: 1, }}>
              {/* <img src={proxelera} style={{ opacity: 0.5 }} /> */}
              <RegMap />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 4 }} sx={{ padding: 1 }}>
              {value === 0 ? <UploadInputs type={"RTL"} loadLogs={loadLogs} /> : false}
              {value === 1 ? <UploadInputs type={"RAL"} loadLogs={loadLogs} /> : false}
              {value === 2 ? <RTLActions type={"RTL-TOP"} loadLogs={loadLogs} /> : false}

            </Grid2>
          </Grid2>
        </Grid2>
        <div style={{ display: 'flex', flexDirection: 'column', position: "absolute", bottom: "10px" }}>
          <LogViewer logs={logs} />
        </div>
      </div>
    </Box >
  );
}

export default DashBoard;
